import { render, staticRenderFns } from "./ConfigurationTabs.vue?vue&type=template&id=70a28aa2&"
import script from "./ConfigurationTabs.vue?vue&type=script&lang=js&"
export * from "./ConfigurationTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationTabs.vue?vue&type=style&index=0&id=70a28aa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports